import ChartDataTable from '@/pages/CompanyReport/components/Overview/components/ChartDataTable';
import DocumentSchema from '@/components/DocumentSchema';
import type { Table } from 'schema-dts';
import { useSelector, shallowEqual } from 'react-redux';
import { selector } from './selector';
import Tooltip from '@/components/Tooltip';
import {
  Term,
  TooltipTitle,
} from '@/pages/CompanyReport/components/Overview/components/Fundamentals/styled';

const IncomeTable = () => {
  const selectedState = useSelector<
    Parameters<typeof selector>[0],
    ReturnType<typeof selector>
  >(selector, shallowEqual);

  const header = `${selectedState?.tickerSymbol} income statement`;
  const caption = `Key profitability statistics from the latest earnings report`;

  return (
    <>
      <DocumentSchema<Table>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: header + ' (TTM)',
          about: caption,
        }}
      />
      <ChartDataTable
        data-cy-id="overview-income-table"
        columnTextAlignments="l"
      >
        <caption>{caption}</caption>
        <thead>
          <tr>
            <th colSpan={2}>
              {header}
              {' ('}
              <Tooltip
                title={<TooltipTitle>Trailing 12 months</TooltipTitle>}
                light
                openDelay={300}
              >
                <Term>TTM</Term>
              </Tooltip>
              {')'}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Revenue</td>
            <td>{selectedState?.revenueFormattedFull}</td>
          </tr>
          <tr>
            <td>Cost of Revenue</td>
            <td>{selectedState?.costOfRevenueFormattedFull}</td>
          </tr>
          <tr>
            <td>Gross Profit</td>
            <td>{selectedState?.grossProfitFormattedFull}</td>
          </tr>
          <tr>
            <td>Other Expenses</td>
            <td>{selectedState?.expensesFormattedFull}</td>
          </tr>
          <tr>
            <td>Earnings</td>
            <td>{selectedState?.earningsFormattedFull}</td>
          </tr>
        </tbody>
      </ChartDataTable>
    </>
  );
};

export default IncomeTable;
